import React from 'react';
import _ from 'lodash';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import ReactTooltip from 'react-tooltip';
import SuggestionNames from './Rows/SuggestionNames';

import Flag from './Rows/Flag';
import Blt from './Rows/Blt';
import Areas from './Rows/Areas';
import Manager from './Rows/Manager';
import PortOfRegistry from './Rows/PortOfRegistry';
import HoldsHatchesTop from './Rows/HoldsHatchesTop';
import Strength from './Rows/Strength';
import StackWeight from './Rows/StackWeight';
import OtherFields from './Rows/OtherFields';
import ImoNumber from './Rows/ImoNumber';
import Name from './Rows/Name';
import Sidebar from './Sidebar';
import BuilderCountry from './Rows/BuilderCountry';
import BuilderYard from './Rows/BuilderYard';
import PIClub from './Rows/PIClub';
import TypeByPurpose from './Rows/TypeByPurpose';
import TypeByConstruction from './Rows/TypeByConstruction';
import TypeBySpecialty from './Rows/TypeBySpecialty';
import GearV2 from './Rows/GearV2';
import GrabV2 from './Rows/GrabV2';
import TechEquipCertificate from './Rows/TechEquipCertificate';
import CargoExclussionsV2 from './Rows/CargoExclussionsV2';
import TradingRestrictions from './Rows/TradingRestrictions';
import Deadweight from './Rows/Deadweight';
import Tonnage from './Rows/Tonnage';
import Dimensions from './Rows/Dimensions';
import CapacityV2 from './Rows/CapacityV2';
import Cells from './Rows/Cells';
import ExNames from './Rows/ExNames';

import { getVessel } from 'services/vessels/vessels';
import { clearVessel } from 'actions/vessels/vessels';
import { getCountries } from 'actions/countries';
import api from 'services';
import Toggle from 'material-ui/Toggle';
import SpeedConsumptionV2 from './Rows/SpeedConsumptionV2';
import Bunkers from './Rows/Bunkers';
import Description from './Rows/Description';
import Design from './Rows/Design';
import DisponentOwner from './Rows/DisponentOwner';
import LinerMeter from './Rows/LinerMeter';
import GearedGrabbed from './Rows/GearedGrabbed';
import { MenuItem, SelectField, TextField } from 'material-ui';
import Nationalities from './Rows/Nationalities';
import RegisterClasses from './Rows/RegisterClasses';
import Checkbox from 'material-ui/Checkbox';
import TypeBySize from './Rows/TypeBySize';
import Pumps from './Rows/Pumps';
import LastCargo from './Rows/LastCargo';
import CapacityTanker from './Rows/CapacityTanker';
import Manifolds from './Rows/Manifolds';
import CertificateOfFitness from './Rows/CertificateOfFitness';
import NumberField from 'components/Base/NumberField';
import RegisteredOwner from './Rows/RegisteredOwner';
import { checkGrabs } from 'helpers/vessels';

function scroll() {
    this.blur();
}

const defaultCargo = {
    cargo: { _id: '', name: '' },
    date: null,
};

function getInitialState() {
    return {
        confirmed: true,
        imoClass: '',
        areas: {},
        capacity: {},
        speeds: {},
        dimensions: {
            loa: undefined,
            beam: undefined,
            depth: undefined,
            lbp: undefined,
        },
        strength: {
            tanktopByHolds: [''],
        },
        stackWeight: {},
        bunkers: [{
            quantity: undefined,
            typeOfFuel: '',
        }],
        consumptions: {
            laden: [],
            ballast: [],
            eco: [],
            portIdle: [],
            portWorking: [],
        },
        holds: { lowerDims: [], tweenDims: [] },
        hatches: { size: [] },
        holdsHatchesProducer: '',

        builderV2: {
            yard: { _id: '', name: '' },
            country: { _id: '', name: '' },
        },
        registerClass: { _id: '', name: '' },
        piClubObject: { _id: '', name: '' },
        iacsRegister: false,
        isRewriteOwnerExclusions: false,
        type: '',
        typeByPurpose: undefined,
        typeByConstruction: undefined,
        typeBySize: '',
        typeBySpecialty: '',
        openHatch: null,
        boxShaped: null,
        gearV2: {
            summary: [
                {
                    type: '',
                    quantity: '',
                    capacity: '',
                    outreach: '',
                    maxSWL: '',
                    combinable: false,
                },
            ],
        },
        gearV2All: [],
        geared: null,
        grabV2: {
            summary: [
                {
                    type: '',
                    quantity: '',
                    volume: '',
                },
            ],
        },
        grabbed: null,
        techEquipCertificate: {
            co2Fitted: null,
            a60BulkheadFitted: null,
            cementHolesCount: '',
            cementHolesDia: '',
            newPanama: null,
            cementHolesFitted: null,
            referPlugFitted: null,
            itfFitted: null,
            lakesFitted: null,
            strengthenHeavy: null,
            logsFitted: null,
            aussieFitted: null,
            iceClass: '',
            ventilation: '',
            ventilationFitted: null,
            imoApp: '',
            imoClass: '',
            imoFitted: null,
            bwts: null,
            coiled: null,
            containerFitted: null,
            carFitted: null,
            rampway: null,
            lxb: '',
            grainFitted: null,
            grainHoles: '',
            grainDia: '',
            cargoTankDryer: null,
            cargoCoolingSystem: null,
            crudeOilWashing: null,
            rcttms: null,
            rctpms: null,
            bowChainStopper: null,
            chainSize: '',
            ngs: null,
            ngsCapacity: '',
            vrs: null,
            vrsNumLines: '',
            bowThruster: null,
            bowThrusterNum: '',
            bowThrusterBhp: '',
            bowThrusterKw: '',
            stemThruster: null,
            stemThrusterNum: '',
            stemThrusterBhp: '',
            stemThrusterKw: '',
            igs: {
                fitted: null,
                systems: [{
                    type: '',
                    capacity: '',
                    percentage: '',
                }],
            },
            referPlugsAmount: undefined,
        },
        design: { _id: '', name: '' },
        cargoExclusionV2List: [],
        cargoExclusionsV2: [],
        tradingRestrictions: [],
        deadWeight: {
            sLoaded: undefined,
            sDWT: undefined,
            sDWCC: undefined,
            sDraft: undefined,
            sTpc: undefined,
            sTpi: undefined,
            tLoaded: undefined,
            tDWT: undefined,
            tDWCC: undefined,
            tDraft: undefined,
            tTpc: undefined,
            tTpi: undefined,
            wLoaded: undefined,
            wDWT: undefined,
            wDWCC: undefined,
            wDraft: undefined,
            wTpc: undefined,
            wTpi: undefined,
            fLoaded: undefined,
            fDWT: undefined,
            fDWCC: undefined,
            fDraft: undefined,
            fTpc: undefined,
            fTpi: undefined,
        },
        rt: {
            gt: undefined,
            nt: undefined,
            suezGt: undefined,
            suezNt: undefined,
            panamaGt: undefined,
            panamaNt: undefined,
        },
        capacityV2: {
            grain: undefined,
            bale: undefined,
            teu: undefined,
            feu: undefined,
            constant: undefined,
            summary: [
                {
                    hold: {
                        grain: undefined,
                        bale: undefined,
                        teu: undefined,
                        feu: undefined,
                    },
                    tweenDeck: {
                        grain: undefined,
                        bale: undefined,
                        teu: undefined,
                        feu: undefined,
                    },
                },
            ],
        },
        capacityTanker: {
            segregation: '',
            details: '',
            ttlCapacity: '',
            cargoGrades: '',
            tanks: [{
                port: '',
                starboard: '',
            }],
            slops: [{
                port: '',
                starboard: '',
            }],
            ballastTanks: [{
                port: '',
                starboard: '',
            }],
            cargoCapacity: '',
            slopsCapacity: '',
            ballastCapacity: '',
            wholeTank: false,
            coatingType: '',
            heating: {
                exchanger: null,
                medium: '',
                maxLoaded: '',
                maxMaintained: '',
            },
        },
        holdsV2: [],
        cells: [{
            holds: {
                l: '',
                b: '',
                h: '',
                area: '',
            },
            tweenDecks: [
                {
                    l: '', b: '', h: '', area: '',
                },
                {
                    l: '', b: '', h: '', area: '',
                },
            ],
            hatches: [
                { l: '', b: '', area: '' },
                { l: '', b: '', area: '' },
            ],
        }],
        temporaryHohaAreas: {
            mainDeckSummArea: null,
            tweenDecksSummArea: null,
            hatchesSummArea: null,
        },
        speedConsumptionV2: [
            {
                mode: '',
                speed: '',
                ifo: {
                    typeIfo: 'HFO 180',
                    cons: '',
                },
                mdo: {
                    typeMdo: 'MGO',
                    cons: '',
                },
                lngCons: undefined,
            },
        ],
        exNames: [],
        nationalities: [],
        registerNumber: '',
        registerClasses: [{ _id: '', name: '' }],
        classNotation: '',
        doubleHull: undefined,
        hullNumber: '',
        callSign: '',
        officialNumber: '',
        mmsi: '',
        pumps: {
            cargo: [{
                type: '',
                quantity: '',
                capacity: '',
            }],
            ballast: [{
                type: '',
                quantity: '',
                capacity: '',
            }],
        },
        lastCargo: [{
            cargoes: [
                _.cloneDeep(defaultCargo),
                _.cloneDeep(defaultCargo),
                _.cloneDeep(defaultCargo),
            ],
        }],
        manifolds: {
            bcm: undefined,
            scm: undefined,
            betweenManifolds: undefined,
            list: [{
                number: undefined,
                size: undefined,
                commonLine: undefined,
            }],
        },
        certificateOfFitness: [],

        flagObject: { _id: '', name: '' },
        managerObject: { _id: '', name: '' },
        ownerObject: { _id: '', name: '' },
        registeredOwnerObject: { _id: '', name: '' },
        homePortObject: { _id: '', name: '' },
        suggestedName: undefined,
        name: undefined,
        imoNumber: undefined,
        image: undefined,
        blt: undefined,
        cargoExclusions: undefined,
        engineLocation: undefined,
        engines: [{
            type: undefined,
            number: undefined,
            capacity: undefined,
            rpm: undefined,
            makeType: undefined,
        }],

        images: [],
        attachments: [],
        attachmentsArray: [],

        typeOfPage: 'new',
        toggleSpeedConsAll: {
            IFO: false,
            MDO: false,
        },
        windScale: undefined,
        description: undefined,
        disponentOwner: { _id: '', name: '' },
        errors: [],
    };
}

class VesselSingle extends React.Component {
    constructor(props) {
        super(props);

        this.state = {
            ...getInitialState(),
            ...props.vessel,
        };

        this.toggleReeferPlugs = this.toggleReeferPlugs.bind(this);

        this.toggleIacsRegister = this.toggleIacsRegister.bind(this);
        this.toggleIsRewriteOwnerExclusions = this.toggleIsRewriteOwnerExclusions.bind(this);

        this.toggleOpenHatch = this.toggleOpenHatch.bind(this);
        this.toggleBoxShaped = this.toggleBoxShaped.bind(this);

        this.changeGeared = this.changeGeared.bind(this);

        this.changeGrabbed = this.changeGrabbed.bind(this);

        this.changeField = this.changeField.bind(this);
        this.getError = this.getError.bind(this);
        this.changeAutoComplete = this.changeAutoComplete.bind(this);

        this.changeHolds = this.changeHolds.bind(this);
        this.changeHatches = this.changeHatches.bind(this);

        this.loadImage = this.loadImage.bind(this);
        this.loadAttachment = this.loadAttachment.bind(this);
        this.removeAttachment = this.removeAttachment.bind(this);
        this.removeImage = this.removeImage.bind(this);

        this.changeAreas = this.changeAreas.bind(this);

        this.fetchVesselDataAndSetToState = this.fetchVesselDataAndSetToState.bind(this);
        this.toggleModifySpeedCons = this.toggleModifySpeedCons.bind(this);
        this.updateSuggestedName = this.updateSuggestedName.bind(this);
        this.clearError = this.clearError.bind(this);
    }

    changeAreas({ field, value, hatchesField }) {
        let { hatchesSummArea } = this.state.temporaryHohaAreas;
        hatchesSummArea = parseFloat(hatchesSummArea) || null;

        let {
            mainDeck, tweenDeck, weatherDeck, total,
        } = this.state.areas;
        mainDeck = parseFloat(mainDeck) || null;
        tweenDeck = parseFloat(tweenDeck) || null;
        weatherDeck = parseFloat(weatherDeck) || null;
        total = parseFloat(total) || null;
        value = parseFloat(value) || null;

        if (field === 'areas.mainDeck') {
            this.changeField({
                field,
                value,
            });
            this.setState({
                areas: {
                    ...this.state.areas,
                    mainDeck: value,
                    total:
                        (value || 0) +
                        (tweenDeck || 0) +
                        (weatherDeck || 0) +
                        (hatchesSummArea || 0),
                },
            });
        } else if (field === 'areas.tweenDeck') {
            this.changeField({
                field,
                value,
            });
            this.setState({
                areas: {
                    ...this.state.areas,
                    tweenDeck: value,
                    total:
                        (value || 0) +
                        (mainDeck || 0) +
                        (weatherDeck || 0) +
                        (hatchesSummArea || 0),
                },
            });
        } else if (field === 'areas.weatherDeck') {
            this.changeField({
                field,
                value,
            });
            this.setState({
                areas: {
                    ...this.state.areas,
                    weatherDeck: value,
                    total:
                        (value || 0) +
                        (mainDeck || 0) +
                        (weatherDeck || 0) +
                        (hatchesSummArea || 0),
                },
            });
        } else if (hatchesField) {
            this.changeField({
                field,
                value,
            });
            const { cells } = this.state;
            hatchesSummArea = 0;
            cells.forEach((cell) => {
                hatchesSummArea +=
                    parseFloat(cell.hatches[0].area || 0) +
                    parseFloat(cell.hatches[1].area || 0);
            });

            this.changeField({
                field: 'temporaryHohaAreas.hatchesSummArea',
                value: hatchesSummArea,
            });
            this.changeField({
                field: 'areas.total',
                value:
                    (hatchesSummArea || 0) +
                    (mainDeck || 0) +
                    (tweenDeck || 0) +
                    (weatherDeck || 0) /* + (total || 0)*/,
            });
        } else {
            let { state } = this;
            state = _.set(state, field, value);
            const { cells, temporaryHohaAreas } = state;

            tweenDeck =
                typeof tweenDeck === 'undefined' ? 0 : parseFloat(tweenDeck);
            weatherDeck = parseFloat(weatherDeck) || 0;

            mainDeck = 0;
            tweenDeck = 0;

            cells.forEach((cell) => {
                mainDeck +=
                    temporaryHohaAreas.mainDeckSummArea +
                    (parseFloat(cell.holds.area) || 0);
                tweenDeck +=
                    (temporaryHohaAreas.tweenDecksSummArea || 0) +
                    (parseFloat(cell.tweenDecks[0].area) || 0) +
                    (parseFloat(cell.tweenDecks[1].area) || 0);
            });

            state.areas.mainDeck = mainDeck;
            state.areas.tweenDeck = tweenDeck;
            state.areas.total =
                mainDeck + tweenDeck + weatherDeck + hatchesSummArea;

            state.errors = state.errors.filter((error) => {
                if (!error.field) {
                    return false;
                }

                return !error.field.includes(field);
            });

            this.setState(state);
        }
    }

    loadImage(e) {
        api.uploadFile({
            file: e.target.files[0],
        })
            .then((response) => {
                this.setState({
                    images: [response.data.data._id],
                    image: response.data.data.url,
                });
            })
            .catch(e1 => this.props.addNotification({
                title: 'Error',
                message: e1.response.data.errors[0].messages[0],
                level: 'error',
                _id: Math.random(),
                autoDismiss: 2,
            }));
    }

    removeImage() {
        this.setState({
            images: [],
            image: undefined,
        });
    }

    loadAttachment(e) {
        const attachments = _.cloneDeep(this.state.attachments);
        const attachmentsArray = _.cloneDeep(this.state.attachmentsArray);

        api.uploadFile({
            file: e.target.files[0],
            type: 'attachment',
        })
            .then((response) => {
                attachmentsArray.push(response.data.data);
                attachments.push(response.data.data._id);

                this.setState({
                    attachmentsArray,
                    attachments,
                });
            })
            .catch(e1 => this.props.addNotification({
                title: 'Error',
                message: e1.response.data.errors[0].messages[0],
                level: 'error',
                _id: Math.random(),
                autoDismiss: 2,
            }));
    }

    removeAttachment(key) {
        const attachments = _.cloneDeep(this.state.attachments);
        const attachmentsArray = _.cloneDeep(this.state.attachmentsArray);

        attachmentsArray.splice(key, 1);
        attachments.splice(key, 1);

        this.setState({
            attachments,
            attachmentsArray,
        });
    }

    checkIfEmptyArray(array) {
        return array.filter((item) => {
            for (const key in item) {
                return !!item[key];
            }
        });
    }

    checkGears(array) {
        return array.filter((item) => {
            if (item.combinable) {
                return true;
            }

            for (const key in item) {
                if (key !== 'combinable') {
                    return !!item[key];
                }
            }
        });
    }

    checkCapacity = array => array.filter((item) => {
        const {
            hold: {
                grain: hg, bale: hb, teu: ht, feu: hf,
            },
            tweenDeck: {
                grain: tg, bale: tb, teu: tt, feu: tf,
            },
        } = item;

        return hg || hb || ht || hf || tg || tb || tt || tf;
    })

    prepareToLoad(vessel) {
        vessel.flag =
            _.has(vessel, 'flagObject._id') && vessel.flagObject._id !== ''
                ? vessel.flagObject._id
                : undefined;
        vessel.piClub =
            _.has(vessel, 'piClubObject._id') && vessel.piClubObject._id !== ''
                ? vessel.piClubObject._id
                : undefined;
        vessel.registeredOwner = vessel.registeredOwnerObject;
        vessel.manager =
            _.has(vessel, 'managerObject._id') &&
                vessel.managerObject._id !== ''
                ? vessel.managerObject._id
                : undefined;
        vessel.homePort =
            _.has(vessel, 'homePortObject._id') &&
                vessel.homePortObject._id !== ''
                ? vessel.homePortObject._id
                : undefined;

        vessel.gearV2.summary = this.checkGears(vessel.gearV2.summary);
        vessel.grabV2.summary = checkGrabs(vessel.grabV2.summary);

        vessel.capacityV2.summary = this.checkCapacity(vessel.capacityV2.summary);

        vessel.bunkers = this.checkIfEmptyArray(vessel.bunkers);
        vessel.capacityV2.summary = this.checkIfEmptyArray(vessel.capacityV2.summary);

        if (!vessel.disponentOwner._id && !vessel.disponentOwner.name) {
            delete vessel.disponentOwner;
        }

        if (vessel.pumps && vessel.pumps.cargo) {
            vessel.pumps.cargo = vessel.pumps.cargo
                .filter(p => p.type || p.quantity || p.capacity);
        }
        if (vessel.pumps && vessel.pumps.ballast) {
            vessel.pumps.ballast = vessel.pumps.ballast
                .filter(p => p.type || p.quantity || p.capacity);
        }
        if (vessel.registerClasses) {
            vessel.registerClasses = vessel.registerClasses
                .filter(c => c._id || c.name || c.iacsRegister)
                .map(c => _.pick(c, ['_id', 'name', 'iacsRegister']));
        }
        if (vessel.capacityTanker.tanks) {
            vessel.capacityTanker.tanks = vessel.capacityTanker.tanks
                .filter(t => t.port || t.starboard);
        }
        if (vessel.capacityTanker.slops) {
            vessel.capacityTanker.slops = vessel.capacityTanker.slops
                .filter(t => t.port || t.starboard);
        }
        if (vessel.capacityTanker.ballastTanks) {
            vessel.capacityTanker.ballastTanks = vessel.capacityTanker.ballastTanks
                .filter(t => t.port || t.starboard);
        }
        if (vessel.manifolds && vessel.manifolds.list) {
            vessel.manifolds.list = vessel.manifolds.list
                .filter(m => m.number || m.size || m.commonLine);
        }
        if (vessel.lastCargo) {
            vessel.lastCargo = vessel.lastCargo
                .map(tank => ({
                    cargoes: tank.cargoes
                        .filter(c => c.cargo._id && c.date)
                        .map(c => ({
                            ...c,
                            cargo: c.cargo._id.toString(),
                        })),
                }));
        }
        if (vessel.certificateOfFitness) {
            vessel.certificateOfFitness = vessel.certificateOfFitness
                .map(c => c._id);
        }
        if (vessel.strength && vessel.strength.tanktopByHolds) {
            vessel.strength.tanktopByHolds = vessel.strength.tanktopByHolds
                .map(s => parseInt(s, 10))
                .filter(s => !isNaN(s));
        }

        delete vessel.registeredOwnerObject;
        delete vessel.dw;
        delete vessel.gears;
        return vessel;
    }

    deleteVessel() {
        this.props.deleteVessel(this.props.parentState);
    }

    toggleReeferPlugs(e, value) {
        this.setState({
            isReeferPlugs: value,
        });
    }

    toggleIacsRegister(e, value) {
        this.setState({
            iacsRegister: value,
        });
    }
    toggleIsRewriteOwnerExclusions(e, value) {
        this.setState({
            isRewriteOwnerExclusions: value,
        });
    }
    toggleOpenHatch(e, value) {
        this.setState({
            openHatch: value,
        });
    }

    toggleBoxShaped(e, value) {
        this.setState({
            boxShaped: value,
        });
    }

    changeGeared(value) {
        const change = {
            geared: value,
        };

        if (!value) {
            const { grabbed, gearV2, grabV2 } = getInitialState();

            change.gearV2 = gearV2;
            change.grabV2 = grabV2;
            change.grabbed = grabbed;
        }

        this.setState(change);
    }

    changeGrabbed(value) {
        const change = {
            grabbed: value,
        };

        if (!value) {
            const { grabV2 } = getInitialState();
            change.grabV2 = grabV2;
        }

        this.setState(change);
    }

    toggleGrabbed(e, value) {
        this.setState({
            grabbed: value,
        });
    }

    toggleModifySpeedCons(type) {
        this.setState({
            toggleSpeedConsAll: {
                ...this.state.toggleSpeedConsAll,
                [type]: !this.state.toggleSpeedConsAll[type],
            },
        });
    }

    changeAutoComplete(type, object) {
        let { state } = this;

        state = _.set(state, type, object._id);
        state = _.set(state, `${type}Object`, {
            name: object.name,
            _id: object._id,
        });

        this.setState(state, () => {
            this.clearError(type);
        });
    }

    changeField(changes) {
        if (!Array.isArray(changes)) {
            changes = [changes];
        }

        let { state } = this;

        changes.forEach(({ field, value, type }) => {
            if (type === 'number' && value === '') {
                value = undefined;
            }

            if (
                (this.state.toggleSpeedConsAll.IFO || this.state.toggleSpeedConsAll.MDO) &&
                (field.endsWith('.typeIfo') || field.endsWith('.typeMdo'))
            ) {
                const {
                    IFO: toggleIfo,
                    MDO: toggleMdo,
                } = this.state.toggleSpeedConsAll;
                const typeFuel = field.replace(/[\[\]]/g, '.').replace(/\.+/g, '.').split('.')[2];
                const speedConsCopy = _.cloneDeep(this.state.speedConsumptionV2);
                const modifiedFieldsCopy = new Set(_.cloneDeep(this.state.modifiedFields));

                typeFuel === 'ifo' &&
                    toggleIfo &&
                    speedConsCopy.forEach((item, index) => {
                        modifiedFieldsCopy.add(`speedConsumptionV2[${index}].ifo.typeIfo`);
                        item[typeFuel].typeIfo = value;
                    });

                typeFuel === 'mdo' &&
                    toggleMdo &&
                    speedConsCopy.forEach((item, index) => {
                        modifiedFieldsCopy.add(`speedConsumptionV2[${index}].mdo.typeMdo`);
                        item[typeFuel].typeMdo = value;
                    });

                _.set(state, 'speedConsumptionV2', speedConsCopy);
                this.setState({
                    currentlyModifiedFields: [...modifiedFieldsCopy],
                    modifiedFields: [...modifiedFieldsCopy],
                });
            }

            if (type === 'array') {
                state = _.set(state, field, [...state[field], value]);
            } else {
                state = _.set(state, field, value);
            }

            state.errors = state.errors.filter((error) => {
                if (!error.field) {
                    return false;
                }

                return !error.field.includes(field.replace(/\[|\]\./g, '.'));
            });
        });

        this.setState(state);
    }

    changeFieldsMultiple = (changes) => {
        let state = _.cloneDeep(this.state);

        if (!Array.isArray(changes)) {
            changes = [changes];
        }

        changes.forEach(({ field, value }) => {
            state = _.set(state, field, value);
        });

        this.setState(state);
    }

    getError(field) {
        if (!this.state.errors.length) {
            return '';
        }

        const errorObject = this.state.errors.find(error => error.field === field);

        return errorObject ? errorObject.messages[0] : '';
    }

    clearError(field) {
        const errors = this.state.errors.filter((error) => {
            if (!error.field) {
                return false;
            }

            return !error.field.includes(field);
        });

        this.setState({
            errors,
        });
    }

    changeSizeArray(array, value) {
        const diff = Math.abs(array.length - value);

        if (value > array.length) {
            for (let i = 0; i <= diff - 1; i++) {
                array.push({});
            }
        } else if (value < array.length) {
            array.splice(value, diff);
        }

        return array;
    }

    changeHolds(value) {
        value = Math.abs(parseInt(value, 10));

        const { state } = this;
        state.holds.quantity = value;

        const lowerDims = _.cloneDeep(state.holds.lowerDims);
        const tweenDims = _.cloneDeep(state.holds.tweenDims);

        state.holds.lowerDims = this.changeSizeArray(lowerDims, value);
        state.holds.tweenDims = this.changeSizeArray(tweenDims, value);

        state.errors = state.errors.filter((error) => {
            if (!error.field) {
                return false;
            }

            return !error.field.includes('holds.quantity');
        });

        this.setState(state);
    }

    changeHatches(value) {
        value = Math.abs(parseInt(value, 10));

        const { state } = this;
        state.hatches.quantity = value;

        const size = _.cloneDeep(state.hatches.size);

        state.hatches.size = this.changeSizeArray(size, value);

        state.errors = state.errors.filter((error) => {
            if (!error.field) {
                return false;
            }

            return !error.field.includes('hatches.quantity');
        });

        this.setState(state);
    }

    findType(type) {
        switch (type) {
        case 'CONT':
        case 'Fully Cellular Container':
            return 'CONT';
        case 'ROLO':
        case 'Passenger/Cargo Vessel':
        case 'Deck Cargo Carrier':
        case 'Ro-Ro/Lo-Lo':
        case 'Reefer/Ro-Ro Cargo':
        case 'Reefer/Pallets Carrier':
        case 'Ro-Ro/Container':
        case 'Product Carrier/Ro-Ro':
        case 'Barge Carrier':
            return 'ROLO';
        case 'RORO':
        case 'Pass./Car Ferry':
        case 'Ro-Ro Freight/Passenger':
        case 'Ro-Ro':
        case 'Pure Car Carrier':
        case 'Palletised Cargo Carrier':
            return 'RORO';
        case 'SID':
        case 'minibulk':
        case 'panamax':
        case 'Miscellaneous Dry Bulk':
        case 'Cement Carrier':
        case 'Aggregate Carrier':
        case 'Bulk Carrier':
        case 'Ore Carrier':
        case 'Ore/Oil Carrier':
        case 'Urea Carrier':
        case 'Open Hatch Carrier':
        case 'Chip Carrier':
        case 'Slurry Carrier':
        case 'handymax':
        case 'Ore & Sulphuric Acid Carrier':
        case 'Forest Product Carrier':
        case 'supramax':
        case 'overpanamax':
        case 'Salt Carrier':
        case 'capesize':
        case 'handysize':
            return 'SID';
        case 'TWEEN':
        case 'General Cargo':
        case 'Reefer':
        case 'Reefer/General Cargo':
        case 'Miscellaneous Cargo':
        case 'Multi-Purpose':
        case 'Multi-Purpose/Heavy Lift Cargo':
        case 'Products/Multi-Purpose Cargo':
        case 'Heavy Lift Cargo Vessel':
            return 'TWEEN';
        case 'Product Carrier':
        case 'Chemical Unknown Carrier':
        case 'Bunkering Vessel':
        case 'Chemical Bulk Tanker':
        case 'Chemical & Oil Carrier':
        case 'Chem Parcel Tanker':
        case 'Molten Sulphur Carrier':
        case 'Asphalt & Bitumen Carrier':
        case 'Tanker':
        case 'Water Carrier':
        case 'Edible Oil Carrier':
        case 'Sulphuric Acid Carrier':
        case 'Oil & Liquid Gas Carrier':
        case 'Fruit Juice Carrier':
        case 'Methanol Carrier':
        case 'Phosphoric Acid Carrier':
        case 'Shuttle Tanker':
        case 'Oil Recovery Tanker':
            return 'TANK';
        case 'Cruise Ship':
        case 'Landing Craft':
        case 'Pass./Car Catamaran Vessel':
        case 'Passenger Vessel':
        case 'Waste Disposal Carrier':
        case 'Livestock Carrier':
        case 'Limestone Carrier':
        case 'Reefer Fish Carrier':
            return 'OTHER';
        }

        return type;
    }

    componentWillUnmount() {
        this.props.clearVessel();
    }

    sortArrayByDate(arr) {
        return [...arr].map(i => ({ ...i, date: new Date(i.date) })).sort((f, s) => s.date - f.date);
    }

    getOldData(vesselData) {
        const vessel = _.merge({}, this.state, vesselData);
        vessel.isReeferPlugs = false;

        vessel.nameSuggestion = undefined;
        vessel.suggestedName = undefined;

        if (
            Array.isArray(vesselData.nameSuggestion) &&
            vesselData.nameSuggestion &&
            vesselData.nameSuggestion.length > 0
        ) {
            vessel.nameSuggestion = this.sortArrayByDate(vesselData.nameSuggestion);
            vessel.suggestedName =
                vessel.nameSuggestion[0];
        }

        // fill old fields

        if (vessel.flag && typeof vessel.flag !== 'string') {
            vessel.flagObject = vessel.flag;
            vessel.flag = vessel.flagObject._id;
        }

        if (vessel.piClub && typeof vessel.piClub !== 'string') {
            vessel.piClubObject = vessel.piClub;
            vessel.piClub = vessel.piClubObject._id;
        }

        if (vessel.registeredOwner) {
            vessel.registeredOwnerObject = vessel.registeredOwner;
        }

        if (vessel.manager && typeof vessel.manager !== 'string') {
            vessel.managerObject = vessel.manager;
            vessel.manager = vessel.managerObject._id;
        }

        if (vessel.homePort && typeof vessel.homePort !== 'string') {
            vessel.homePortObject = vessel.homePort;
            vessel.homePort = vessel.homePortObject._id;
        }

        if (vessel.images.length > 0 && typeof vessel.images[0] !== 'string') {
            vessel.image = vessel.images[0].url;
            vessel.images[0] = vessel.images[0]._id;
        }

        if (vessel.reeferPlugs && vessel.reeferPlugs > 0) {
            vessel.isReeferPlugs = true;
        }

        if (_.has(vessel.attachments[0], 'name')) {
            vessel.attachmentsArray = [];

            vessel.attachments.forEach((item) => {
                vessel.attachmentsArray.push(item);
            });

            vessel.attachments = [];

            vessel.attachmentsArray.forEach((item) => {
                vessel.attachments.push(item._id);
            });
        }

        if (vessel.rt) {
            vessel.rt.panamaNt = vessel.rt.panamaNt || undefined;
            vessel.rt.suezGt = vessel.rt.suezGt || undefined;
            vessel.rt.suezNt = vessel.rt.suezNt || undefined;
            vessel.rt.nt = vessel.rt.nt || undefined;
            vessel.rt.gt = vessel.rt.gt || undefined;
        }

        if (vessel.dimensions) {
            vessel.dimensions.loa = vessel.dimensions.loa || undefined;
            vessel.dimensions.beam = vessel.dimensions.beam || undefined;
            vessel.dimensions.depth = vessel.dimensions.depth || undefined;
            vessel.dimensions.lbp = vessel.dimensions.lbp || undefined;
        }

        if (vessel.areas) {
            vessel.areas.mainDeck = vessel.areas.mainDeck || undefined;
            vessel.areas.tweenDeck = vessel.areas.tweenDeck || undefined;
            vessel.areas.weatherDeck = vessel.areas.weatherDeck || undefined;
            vessel.areas.total = vessel.areas.total || undefined;
        }

        if (vessel.strength) {
            vessel.strength.maxTt = vessel.strength.maxTt || undefined;
            vessel.strength.maxTween = vessel.strength.maxTween || undefined;
            vessel.strength.maxWeather =
                vessel.strength.maxWeather || undefined;
        }

        if (vessel.stackWeight) {
            vessel.stackWeight['20hold'] =
                vessel.stackWeight['20hold'] || undefined;
            vessel.stackWeight['20deck'] =
                vessel.stackWeight['20deck'] || undefined;
            vessel.stackWeight['40hold'] =
                vessel.stackWeight['40hold'] || undefined;
            vessel.stackWeight['40deck'] =
                vessel.stackWeight['40deck'] || undefined;
        }

        if (vessel.holds) {
            vessel.holds.quantity = vessel.holds.quantity || undefined;

            if (vessel.holds.lowerDims && vessel.holds.lowerDims.length) {
                vessel.holds.lowerDims.forEach((dim) => {
                    dim.l = dim.l || undefined;
                    dim.b = dim.b || undefined;
                    dim.h = dim.h || undefined;
                });
            }

            if (vessel.holds.tweenDims && vessel.holds.tweenDims.length) {
                vessel.holds.tweenDims.forEach((dim) => {
                    dim.l = dim.l || undefined;
                    dim.b = dim.b || undefined;
                    dim.h = dim.h || undefined;
                });
            }
        }
        if (vessel.hatches) {
            if (vessel.hatches.hatchType === 'Mc Greegor') {
                vessel.hatches.hatchType = 'Mc Gregor';
            }
            if (vessel.hatches.size && vessel.hatches.size.length) {
                vessel.hatches.size.forEach((dim) => {
                    dim.l = dim.l || undefined;
                    dim.b = dim.b || undefined;
                });
            }
        }

        vessel.draft = vessel.draft || undefined;

        for (const tank of vessel.lastCargo) {
            for (let i = tank.cargoes.length; i < 3; i++) {
                tank.cargoes.push(_.cloneDeep(defaultCargo));
            }
        }

        if (vessel.registerClass && vessel.registerClass._id && !vessel.registerClasses[0]._id && vessel.registerClasses.length === 1) {
            vessel.registerClasses[0] = _.cloneDeep(vessel.registerClass);
        }

        return vessel;
    }

    updateSuggestedName(sName) {
        const { name } = this.state;

        this.setState({
            suggestedName: sName && sName.name ? sName : name,
        });
    }

    fetchVesselDataAndSetToState(id) {
        getVessel(id).then(async (response) => {
            response.data.type = this.findType(response.data.type);

            Object.keys(response.data).forEach((item) => {
                const obj = response.data[item];
                // remove empty objects
                if (
                    obj === null || obj === undefined ||
                    (Array.isArray(obj) && obj.length === 0) ||
                    (Object.keys(obj).length === 0 &&
                        obj.constructor === Object)
                ) {
                    delete response.data[item];
                }
            });

            const vessel = this.getOldData(response.data);

            this.setState({
                ...vessel,
                typeOfPage: 'update',
            });
        });
    }

    componentDidMount() {
        this.changeField({
            field: 'temporaryHohaAreas',
            value: {
                mainDeckSummArea: parseFloat(this.state.areas.mainDeck) || 0,
                tweenDecksSummArea: parseFloat(this.state.areas.tweenDeck) || 0,
            },
        });

        let { typeOfPage } = this.state;
        if (this.props.params.id) {
            this.setState(getInitialState(), () => {
                this.fetchVesselDataAndSetToState(this.props.params.id);
            });
            typeOfPage = 'update';
        }

        this.setState({
            typeOfPage,
        });
    }

    UNSAFE_componentWillReceiveProps(nextProps) {
        if (nextProps.params.id !== this.props.params.id) {
            this.setState(getInitialState(), () => {
                this.fetchVesselDataAndSetToState(this.props.params.id);
            });
        }
    }

    componentDidUpdate() {
        /* delete scroll event listener from input elements */
        const inputs = document.querySelectorAll('input[type=number]');

        inputs.forEach((input) => {
            input.removeEventListener('mousewheel', scroll);
            input.addEventListener('mousewheel', scroll);
        });
    }

    render() {
        const {
            _id,
            areas,
            flagObject,

            builderV2,
            registerClass,
            piClubObject,
            isRewriteOwnerExclusions,
            typeByPurpose,
            typeByConstruction,
            typeBySpecialty,
            typeBySize,
            openHatch,
            boxShaped,
            gearV2,
            geared,
            grabV2,
            grabbed,
            techEquipCertificate,
            cargoExclusionV2Object,
            cargoExclusionV2List,
            cargoExclusionsV2,
            tradingRestrictions,
            deadWeight,
            holds,
            dimensions,
            capacityV2,
            cells,
            temporaryHohaAreas,
            speedConsumptionV2,
            exNames,

            managerObject,
            // ownerObject,
            registeredOwnerObject,
            bunkers,
            hatches,
            holdsHatchesProducer,
            strength,
            stackWeight,
            typeOfPage,
            name,
            imoNumber,
            blt,
            rt,
            engineLocation,
            engines,
            confirmed,
            homePortObject,
            toggleSpeedConsAll,
            windScale,
            description,
            design,
            disponentOwner,
            linerMeter,
            nationalities,
            registerNumber,
            registerClasses,
            classNotation,
            doubleHull,
            hullNumber,
            callSign,
            officialNumber,
            mmsi,
            pumps,
            lastCargo,
            capacityTanker,
            manifolds,
            certificateOfFitness,
            markForDeletion,
            markForDeletionDate,
        } = this.state;

        if (_.isEmpty(this.state)) {
            return null;
        }

        const linerMeterDisabled = !(new RegExp('ro-(ro|lo)', 'i').test(typeBySpecialty));

        return (
            <div id="vessel-single" className="page container">
                <ReactTooltip type="light" border offset={15} />
                <div className="paper-block ">
                    <form ref="form">
                        <div className="row">
                            <div
                                className="col-xs-3"
                                style={
                                    this.state.attachmentsArray.length <= 7 || window.screen.height < 700 ?
                                        { position: 'fixed', width: 'min-content', minWidth: '19em' }
                                        :
                                        { position: 'absolute' }
                                }
                            >
                                <Sidebar
                                    loadImage={this.loadImage}
                                    removeImage={this.removeImage}
                                    loadAttachment={this.loadAttachment}
                                    removeAttachment={this.removeAttachment}
                                    parentState={this.state}
                                    changeField={this.changeField}
                                    typeOfPage={typeOfPage}
                                    confirmed={!confirmed}
                                    markForDeletion={markForDeletion}
                                    markForDeletionDate={markForDeletionDate}
                                />
                            </div>

                            <div className="col-xs-offset-3 col-xs-9">
                                <div className="paper-block margin-bottom">
                                    <div className="row">
                                        <div className="col-xs-5">
                                            <Name
                                                name={name}
                                                confirmed={!confirmed}
                                                changeField={this.changeField}
                                                getError={this.getError}
                                            />
                                        </div>
                                        <ExNames
                                            exNames={exNames}
                                            confirmed={!confirmed}
                                            changeField={this.changeField}
                                            getError={this.getError}
                                        />
                                    </div>
                                    {this.state.nameSuggestion && this.state.suggestedName && (
                                        <div className="row">
                                            <div className="col-xs-5" />
                                            <SuggestionNames
                                                key={_id}
                                                refreshVessel={() =>
                                                    this.fetchVesselDataAndSetToState(this.props.params.id)
                                                }
                                                updateSuggestedName={
                                                    this.updateSuggestedName
                                                }
                                                vessel={this.state}
                                            />
                                        </div>
                                    )}
                                    <div className="row">
                                        <div className="col-xs-5">
                                            <ImoNumber
                                                imoNumber={imoNumber}
                                                confirmed={!confirmed}
                                                typeOfPage={typeOfPage}
                                                changeField={this.changeField}
                                                getError={this.getError}
                                            />
                                        </div>
                                        <Nationalities
                                            value={nationalities}
                                            confirmed={!confirmed}
                                            changeField={this.changeField}
                                            getError={this.getError}
                                        />
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-3">
                                            <Blt
                                                blt={blt}
                                                confirmed={!confirmed}
                                                changeField={this.changeField}
                                                getError={this.getError}
                                            />
                                        </div>
                                        <div className="col-xs-9">
                                            <div className="row">
                                                <div className="col-xs-2">
                                                    <div
                                                        style={{
                                                            margin:
                                                                '40px 0 0 40px',
                                                        }}
                                                    >
                                                        Builder:
                                                    </div>
                                                </div>
                                                <div className="col-xs-5">
                                                    <BuilderYard
                                                        getError={this.getError}
                                                        changeField={
                                                            this.changeField
                                                        }
                                                        yard={builderV2.yard}
                                                        confirmed={!confirmed}
                                                    />
                                                </div>
                                                <div className="col-xs-5">
                                                    <BuilderCountry
                                                        getError={this.getError}
                                                        changeAutoComplete={
                                                            this
                                                                .changeAutoComplete
                                                        }
                                                        country={
                                                            builderV2.country
                                                        }
                                                        confirmed={!confirmed}
                                                    />
                                                </div>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-4">
                                            <Flag
                                                changeAutoComplete={
                                                    this.changeAutoComplete
                                                }
                                                getError={this.getError}
                                                flagObject={flagObject}
                                                confirmed={!confirmed}
                                            />
                                        </div>
                                        <div className="col-xs-4">
                                            <PortOfRegistry
                                                homePortObject={homePortObject}
                                                confirmed={!confirmed}
                                                changeAutoComplete={
                                                    this.changeAutoComplete
                                                }
                                                getError={this.getError}
                                            />
                                        </div>
                                        <div className='col-xs-4'>
                                            <TextField
                                                name="registerNumber"
                                                disabled={!confirmed}
                                                value={registerNumber}
                                                floatingLabelText='Registry №'
                                                onChange={e => this.changeField(/** @type {any} */({
                                                    field: 'registerNumber',
                                                    value: /** @type {HTMLInputElement} */ (e.currentTarget).value,
                                                }))}
                                                fullWidth
                                            />
                                        </div>
                                    </div>
                                    <RegisterClasses
                                        registerClasses={registerClasses}
                                        changeField={this.changeFieldsMultiple}
                                        confirmed={confirmed}
                                        getError={this.getError}
                                        clearError={this.clearError}
                                    />
                                    <TextField
                                        name="classNotation"
                                        disabled={!confirmed}
                                        value={classNotation}
                                        floatingLabelText='Class notation'
                                        onChange={e => this.changeField(/** @type {any} */({
                                            field: 'classNotation',
                                            value: /** @type {HTMLInputElement} */ (e.currentTarget).value,
                                        }))}
                                        fullWidth
                                    />
                                    <div className='row'>
                                        <div className='col-xs-4'>
                                            <PIClub
                                                piClubObject={piClubObject}
                                                changeField={this.changeField}
                                                confirmed={!confirmed}
                                                getError={this.getError}
                                                clearError={this.clearError}
                                            />
                                        </div>
                                        <div className='col-xs-4'>
                                            <RegisteredOwner
                                                _registeredOwnerObject={registeredOwnerObject}
                                                confirmed={!confirmed}
                                                changeAutoComplete={this.changeAutoComplete}
                                                getError={this.getError}
                                            />
                                        </div>
                                        <div className='col-xs-4'>
                                            <Manager
                                                managerObject={managerObject}
                                                confirmed={!confirmed}
                                                changeAutoComplete={this.changeAutoComplete}
                                                getError={this.getError}
                                            />
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-xs-4">
                                            <Design
                                                design={design}
                                                confirmed={!confirmed}
                                                changeField={this.changeField}
                                                getError={this.getError}
                                            />
                                        </div>
                                        <div className='col-xs-4'>
                                            <DisponentOwner
                                                changeField={this.changeField}
                                                confirmed={!confirmed}
                                                disponentOwner={disponentOwner}
                                            />
                                        </div>
                                        <div
                                            className="col-xs-2 middle-xs start-xs"
                                            style={{ display: 'flex' }}
                                        >
                                            <SelectField
                                                value={openHatch}
                                                onChange={(e, i, value) => this.changeFieldsMultiple([{ field: 'openHatch', value }])}
                                                disabled={!confirmed}
                                                name='openHatch'
                                                floatingLabelText='Open Hatch'
                                                floatingLabelStyle={{ fontSize: '13px' }}
                                                autoWidth
                                                fullWidth
                                            >
                                                <MenuItem value={null} primaryText={undefined} />
                                                <MenuItem value primaryText='Yes' />
                                                <MenuItem value={false} primaryText='No' />
                                            </SelectField>
                                        </div>
                                        <div
                                            className="col-xs-2 middle-xs start-xs"
                                            style={{ display: 'flex' }}
                                        >
                                            <SelectField
                                                value={boxShaped}
                                                onChange={(e, i, value) => this.changeFieldsMultiple([{ field: 'boxShaped', value }])}
                                                disabled={!confirmed}
                                                name='boxShaped'
                                                floatingLabelText='Box Shaped'
                                                floatingLabelStyle={{ fontSize: '13px' }}
                                                autoWidth
                                                fullWidth
                                            >
                                                <MenuItem value={null} primaryText={undefined} />
                                                <MenuItem value primaryText='Yes' />
                                                <MenuItem value={false} primaryText='No' />
                                            </SelectField>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-xs-4">
                                            <Checkbox
                                                style={{ margin: '40px 0 0' }}
                                                label='Double hull'
                                                checked={doubleHull}
                                                disabled={!confirmed}
                                                onCheck={() => this.changeField(/** @type {any} */({
                                                    field: 'doubleHull',
                                                    value: !doubleHull,
                                                }))}
                                            />
                                        </div>
                                        <div className='col-xs-4'>
                                            <TextField
                                                name="hullNumber"
                                                disabled={!confirmed}
                                                value={hullNumber}
                                                floatingLabelText='Hull number'
                                                onChange={e => this.changeField(/** @type {any} */({
                                                    field: 'hullNumber',
                                                    value: /** @type {HTMLInputElement} */ (e.currentTarget).value,
                                                }))}
                                                fullWidth
                                            />
                                        </div>
                                        <div className='col-xs-4'>
                                            <TextField
                                                name="callSign"
                                                disabled={!confirmed}
                                                value={callSign}
                                                floatingLabelText='Call sign'
                                                onChange={e => this.changeField(/** @type {any} */({
                                                    field: 'callSign',
                                                    value: /** @type {HTMLInputElement} */ (e.currentTarget).value,
                                                }))}
                                                fullWidth
                                            />
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className="col-xs-4">
                                            <TextField
                                                name="officialNumber"
                                                disabled={!confirmed}
                                                value={officialNumber}
                                                floatingLabelText='Official number'
                                                onChange={e => this.changeField(/** @type {any} */({
                                                    field: 'officialNumber',
                                                    value: /** @type {HTMLInputElement} */ (e.currentTarget).value,
                                                }))}
                                                fullWidth
                                            />
                                        </div>
                                        <div className="col-xs-4">
                                            <TextField
                                                name="mmsi"
                                                disabled={!confirmed}
                                                value={mmsi}
                                                floatingLabelText='MMSI'
                                                onChange={e => this.changeField(/** @type {any} */({
                                                    field: 'mmsi',
                                                    value: /** @type {HTMLInputElement} */ (e.currentTarget).value,
                                                }))}
                                                fullWidth
                                            />
                                        </div>
                                        <div className='col-xs-4'>
                                            <LinerMeter
                                                linerMeter={linerMeter}
                                                linerMeterDisabled={linerMeterDisabled}
                                                changeFieldsMultiple={this.changeFieldsMultiple}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-3" id="typeByPurposeSection">
                                            <TypeByPurpose
                                                type={typeByPurpose}
                                                confirmed={!confirmed}
                                                changeField={this.changeFieldsMultiple}
                                                getError={this.getError}
                                            />
                                        </div>
                                        <div className='col-xs-3'>
                                            <TypeBySpecialty
                                                typeBySpecialty={typeBySpecialty}
                                                confirmed={!confirmed}
                                                changeField={this.changeFieldsMultiple}
                                                getError={this.getError}
                                                typeByPurpose={typeByPurpose}
                                            />
                                        </div>
                                        <div className='col-xs-3'>
                                            <TypeByConstruction
                                                type={typeByConstruction}
                                                confirmed={!confirmed}
                                                changeField={this.changeField}
                                                getError={this.getError}
                                            />
                                        </div>
                                        <div className='col-xs-3'>
                                            <TypeBySize
                                                type={typeBySize}
                                                confirmed={confirmed}
                                                changeField={this.changeFieldsMultiple}
                                                getError={this.getError}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="paper-block margin-bottom">
                                    <div className="row">
                                        <div className="col-xs-1">
                                            <span className="name-block static huge-name">
                                                GEAR:
                                            </span>
                                        </div>
                                        <div
                                            className="col-xs-3 col-xs-offset-8"
                                        >
                                            <GearedGrabbed
                                                confirmed={confirmed}
                                                fieldName='geared'
                                                gearedGrabbed={geared}
                                                onChange={this.changeGeared}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <GearV2
                                                gearV2={gearV2}
                                                confirmed={!confirmed}
                                                changeField={this.changeField}
                                                getError={this.getError}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="paper-block margin-bottom">
                                    <div className="row">
                                        <div className="col-xs-1">
                                            <span className="name-block static huge-name">
                                                GRABS:
                                            </span>
                                        </div>
                                        <div className="col-xs-3 col-xs-offset-8">
                                            <GearedGrabbed
                                                confirmed={confirmed}
                                                fieldName='grabbed'
                                                gearedGrabbed={grabbed}
                                                onChange={this.changeGrabbed}
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <GrabV2
                                                grabs={grabV2}
                                                confirmed={!confirmed}
                                                changeField={this.changeField}
                                                getError={this.getError}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="paper-block margin-bottom">
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <span className="name-block static huge-name">
                                                PUMPS:
                                            </span>
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-xs-12'>
                                            <Pumps
                                                type='cargo'
                                                pumps={pumps.cargo}
                                                confirmed={!confirmed}
                                                changeField={this.changeFieldsMultiple}
                                                getError={this.getError}
                                            />
                                        </div>
                                    </div>
                                    <div className='row'>
                                        <div className='col-xs-12'>
                                            <Pumps
                                                type='ballast'
                                                pumps={pumps.ballast}
                                                confirmed={!confirmed}
                                                changeField={this.changeFieldsMultiple}
                                                getError={this.getError}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="paper-block margin-bottom">
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <TechEquipCertificate
                                                confirmed={!confirmed}
                                                techEquipCertificate={
                                                    techEquipCertificate
                                                }
                                                changeField={this.changeField}
                                                getError={this.getError}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="paper-block margin-bottom">
                                    <span className="name-block static huge-name">
                                        TONNAGE, reg tons
                                    </span>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <Tonnage
                                                confirmed={!confirmed}
                                                rt={rt}
                                                changeField={this.changeField}
                                                getError={this.getError}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="paper-block margin-bottom">
                                    <div className="row">
                                        <div className="col-xs-8">
                                            <span className="name-block static huge-name">
                                                CARGO EXCLUSIONS
                                            </span>
                                        </div>
                                        <div className="col-xs-4">
                                            <div style={{ margin: '0 0 15px 35px' }}>
                                                <Toggle
                                                    disabled={!confirmed}
                                                    label="Rewrite owners exclusions"
                                                    toggled={isRewriteOwnerExclusions}
                                                    onToggle={
                                                        this.toggleIsRewriteOwnerExclusions
                                                    }
                                                />
                                            </div>
                                        </div>
                                    </div>
                                    <div style={{ marginBottom: '15px' }} className="row">
                                        <div className="col-xs-12">
                                            <CargoExclussionsV2
                                                cargoExclusionV2Object={
                                                    cargoExclusionV2Object
                                                }
                                                cargoExclusionV2List={
                                                    cargoExclusionV2List
                                                }
                                                cargoExclusionsV2={
                                                    cargoExclusionsV2
                                                }
                                                deleteOwners={isRewriteOwnerExclusions}
                                                confirmed={!confirmed}
                                                changeField={this.changeField}
                                                getError={this.getError}
                                            />
                                        </div>
                                    </div>
                                    <span className="name-block static huge-name">
                                        TRADING RESTRICTIONS
                                    </span>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <TradingRestrictions
                                                deleteOwners={isRewriteOwnerExclusions}
                                                tradingRestrictions={
                                                    tradingRestrictions
                                                }
                                                confirmed={!confirmed}
                                                changeField={this.changeField}
                                                getError={this.getError}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="paper-block margin-bottom">
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <span className="name-block static huge-name">
                                                Last 3 Cargo
                                            </span>
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <LastCargo
                                                lastCargo={lastCargo}
                                                disabled={!confirmed}
                                                changeField={this.changeField}
                                                getError={this.getError}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="paper-block margin-bottom">
                                    <div style={{ float: 'right', marginTop: '-28px' }}>
                                        <NumberField
                                            name="capacityV2.constant"
                                            disabled={!confirmed}
                                            value={capacityV2.constant}
                                            floatingLabelText="Constant, mt"
                                            onChange={(e, value) => this.changeField(/** @type {any} */({
                                                field: 'capacityV2.constant',
                                                value,
                                            }))}
                                            fullWidth
                                            floatNumber
                                        />
                                    </div>
                                    <span className="name-block static huge-name" id="deadweightSection">
                                        DEADWEIGHT / OTHER
                                    </span>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <Deadweight
                                                deadWeight={deadWeight}
                                                dimensions={dimensions}
                                                confirmed={!confirmed}
                                                changeField={this.changeField}
                                                getError={this.getError}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="paper-block margin-bottom">
                                    <span className="name-block static huge-name">
                                        CAPACITY GENERAL
                                    </span>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <CapacityV2
                                                capacityV2={capacityV2}
                                                confirmed={!confirmed}
                                                changeField={this.changeField}
                                                getError={this.getError}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="paper-block margin-bottom">
                                    <span className="name-block static huge-name">
                                        HO/HA
                                    </span>

                                    <HoldsHatchesTop
                                        holds={holds}
                                        confirmed={!confirmed}
                                        hatches={hatches}
                                        holdsHatchesProducer={holdsHatchesProducer}
                                        changeHolds={this.changeHolds}
                                        changeHatches={this.changeHatches}
                                        changeField={this.changeField}
                                        getError={this.getError}
                                    />
                                    <Cells
                                        cells={cells}
                                        changeAreas={this.changeAreas}
                                        changeField={this.changeField}
                                        confirmed={!confirmed}
                                        getError={this.getError}
                                        temporaryHohaAreas={temporaryHohaAreas}
                                    />

                                    <Areas
                                        areas={areas}
                                        confirmed={!confirmed}
                                        changeAreas={this.changeAreas}
                                        changeField={this.changeField}
                                        getError={this.getError}
                                    />
                                </div>

                                <div className="paper-block margin-bottom">
                                    <span className="name-block static huge-name">
                                        CAPACITY TANKER
                                    </span>
                                    <CapacityTanker
                                        capacityTanker={capacityTanker}
                                        confirmed={!confirmed}
                                        changeField={this.changeField}
                                        getError={this.getError}
                                    />
                                </div>

                                <div className="paper-block margin-bottom">
                                    <span className="name-block static huge-name">
                                        DIMENSIONS, m
                                    </span>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <Dimensions
                                                dimensions={dimensions}
                                                deadWeight={deadWeight}
                                                confirmed={!confirmed}
                                                changeField={this.changeField}
                                                getError={this.getError}
                                            />
                                        </div>
                                    </div>
                                </div>

                                <div className="paper-block margin-bottom">
                                    <span className="name-block static huge-name">
                                        MANIFOLDS
                                    </span>
                                    <Manifolds
                                        manifolds={manifolds}
                                        confirmed={!confirmed}
                                        changeField={this.changeField}
                                        getError={this.getError}
                                    />
                                </div>

                                <div className="paper-block margin-bottom">
                                    <div className="row">
                                        <div className="col-xs-3">
                                            <span className="name-block static huge-name">
                                                SPEED & CONSUMPTION:
                                            </span>
                                        </div>
                                        <div
                                            className="col-xs-offset-5"
                                            style={{ marginTop: '2px' }}
                                        >
                                            <span
                                                className="name-block static huge-name"
                                                style={{
                                                    color: '#b0b0b0',
                                                    fontSize: '14px',
                                                }}
                                            >
                                                Modify all:
                                            </span>
                                        </div>
                                        <div className="col-xs-1">
                                            <Toggle
                                                name="modifyAllIfo"
                                                label="IFO"
                                                disabled={!confirmed}
                                                toggled={toggleSpeedConsAll.IFO}
                                                onToggle={() =>
                                                    this.toggleModifySpeedCons('IFO')
                                                }
                                            />
                                        </div>
                                        <div className="col-xs-1">
                                            <Toggle
                                                name="modifyAllMdo"
                                                label="MDO"
                                                disabled={!confirmed}
                                                toggled={toggleSpeedConsAll.MDO}
                                                onToggle={() =>
                                                    this.toggleModifySpeedCons('MDO')
                                                }
                                            />
                                        </div>
                                    </div>
                                    <div className="row">
                                        <div className="col-xs-12">
                                            <SpeedConsumptionV2
                                                speedConsumptionV2={
                                                    speedConsumptionV2
                                                }
                                                confirmed={!confirmed}
                                                changeField={this.changeField}
                                                getError={this.getError}
                                            />
                                        </div>
                                    </div>
                                </div>
                                <div className="paper-block margin-bottom">
                                    <span className="name-block static huge-name">
                                        BUNKERS
                                    </span>
                                    <Bunkers
                                        bunkers={bunkers}
                                        confirmed={!confirmed}
                                        changeField={this.changeField}
                                        getError={this.getError}
                                    />
                                </div>
                                <div className="paper-block margin-bottom">
                                    <span className="name-block static huge-name">
                                        PERMISSIBLE LOADS
                                    </span>
                                    <Strength
                                        strength={strength}
                                        confirmed={!confirmed}
                                        changeField={this.changeField}
                                        getError={this.getError}
                                    />

                                    <StackWeight
                                        stackWeight={stackWeight}
                                        confirmed={!confirmed}
                                        changeField={this.changeField}
                                        getError={this.getError}
                                    />
                                </div>

                                <div className="paper-block margin-bottom">
                                    <span className="name-block static huge-name">
                                        CERTIFICATE OF FITNESS
                                    </span>
                                    <CertificateOfFitness
                                        confirmed={confirmed}
                                        certificateOfFitness={certificateOfFitness}
                                        changeField={this.changeField}
                                    />
                                </div>

                                <div className="paper-block margin-bottom">
                                    <span className="name-block static huge-name">
                                        OTHER FIELDS
                                    </span>
                                    <OtherFields
                                        confirmed={!confirmed}
                                        engineLocation={engineLocation}
                                        engines={engines}
                                        windScale={windScale}
                                        changeField={this.changeField}
                                        getError={this.getError}
                                    />
                                </div>
                                <div className="paper-block margin-bottom">
                                    <span className="name-block static huge-name">
                                        DESCRIPTION
                                    </span>
                                    <Description
                                        confirmed={!confirmed}
                                        description={description}
                                        changeField={this.changeField}
                                        getError={this.getError}
                                    />
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        );
    }
}

export default connect(
    ({ countries, vessel, user: { isLogged } }) => ({
        countries: countries.items,
        vessel,
        isLogged,
    }),
    dispatch => bindActionCreators({
        getVessel,
        getCountries,
        clearVessel,
    }, dispatch),
)(VesselSingle);



// WEBPACK FOOTER //
// ./app/components/Vessels/Single/Page.jsx